import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';


export default function SubscriptionBasicInfoComponent ({programs,handleInnerFormChange, subscriptionDetails}: any) {
 console.log(subscriptionDetails,'subscriptionDetails')
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
     
<InputContainer
              label="Program Name"
              labelField="Name"
              list={programs}
              onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'OwnerId');
                }
              }
              optionName='choose Programs'
              type="select"
              value={subscriptionDetails?.OwnerId}
              valueField="Id"
            />



  </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>


        </>
  )
}